import { useNavigate } from 'react-router-dom';
import { useSidebarContext } from '@/context/SidebarContext';
import { useAuthContext } from '@/context/AuthContext';
import { ROUTES } from '@/constants';
import { Menu, PanelLeftClose, LogOut, EyeOff, Users, Shield } from 'lucide-react';

import { ThemePalettePicker } from '@/components/layout/ThemePalettePicker';
import { useAppDispatch } from '@/store/hooks';
import { toggleHideHeader } from '@/store/slices/uiSlice';

export function Header() {
    const { toggle, toggleCollapse } = useSidebarContext();
    const { user, logout } = useAuthContext();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleLogout = () => {
        logout();
        navigate(ROUTES.HOME, { replace: true });
    };

    return (
        <header className="flex h-14 items-center justify-between border-b border-border bg-card px-6">
            <div className="flex items-center gap-2">
                <button
                    onClick={toggle}
                    className="rounded-md p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                    aria-label="Toggle sidebar"
                >
                    <Menu className="h-4 w-4" />
                </button>
                <button
                    onClick={toggleCollapse}
                    className="rounded-md p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                    aria-label="Collapse sidebar"
                >
                    <PanelLeftClose className="h-4 w-4" />
                </button>
            </div>

            <div className="flex items-center gap-2 sm:gap-4">
                <ThemePalettePicker />
                <button
                    type="button"
                    onClick={() => dispatch(toggleHideHeader())}
                    className="rounded-md p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring/40"
                    aria-label="Hide header"
                    title="Hide header"
                >
                    <EyeOff className="h-4 w-4" aria-hidden />
                </button>
                <span className="text-sm font-medium text-muted-foreground">
                    {user?.role || 'User'}
                </span>
                <button
                    onClick={() => navigate('/dashboard/settings/profile')}
                    className="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                >
                    <Users className="h-3.5 w-3.5" />
                    Profile
                </button>
                <button
                    onClick={() => navigate('/dashboard/settings/security')}
                    className="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                >
                    <Shield className="h-3.5 w-3.5" />
                    Security
                </button>
                <button
                    onClick={handleLogout}
                    className="flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                >
                    <LogOut className="h-3.5 w-3.5" />
                    Logout
                </button>

            </div>
        </header>
    );
}

export default Header;
